import type { IMausoleum, IMausoleumApi } from 'src/interfaces';

export const mapApiToMausoleum = ({ mausoleum_name, ...rest }: IMausoleumApi): IMausoleum => ({
  ...rest,
  mausoleumName: mausoleum_name,
});
